import { render } from "./ManualDataList.vue?vue&type=template&id=3dedf872"
import script from "./ManualDataList.vue?vue&type=script&lang=js"
export * from "./ManualDataList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__